import { Injectable } from '@angular/core';
import { AngularFirestore,AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { Image } from '../../models/models';
 
@Injectable()
export class ImageService {
	
	private urlPath = '/images'; 
   // private imageListRef = this.db.list<Image>(this.urlPath);
    private imageListCollection:AngularFirestoreCollection<Image> = this.afs.collection(this.urlPath);
 
    constructor(private afs: AngularFirestore) { }
 
    getImageList() {
       // return this.imageListRef;
        return this.imageListCollection;
    }
	
	getImage(key:string){
		//return this.db.object<Image>(`${this.urlPath}/${key}`)
		return this.afs.doc<Image>(`${this.urlPath}/${key}`);
	}
 
    addImage(image: Image) {
        //return this.imageListRef.push(image);
		let id = this.afs.createId();
		
		this.afs.collection<Image>(this.urlPath).doc(id).set(image);
		return id;
    }
 
    updateImage(key:string, image: Image) {
        //return this.imageListRef.update(key, image);
		
		return	this.afs.doc<Image>(`${this.urlPath}/${key}`).update(image);
    }
 
    removeImage(key:string) {
        //return this.imageListRef.remove(key);
		
		return	this.afs.doc<Image>(`${this.urlPath}/${key}`).delete();
    }
}


